import { FC, HTMLAttributes, memo } from 'react';
import cn from 'classnames';

import List from '@UI/List';
import { SizeData } from '@Types/Product';
import styles from './Sizes.module.css';

export interface SizesProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  sizes: SizeData[];
}

const Sizes: FC<SizesProps> = (props) => {
  const { className, sizes, ...restProps } = props;

  return (
    <List
      {...restProps}
      className={cn(styles.sizes, { [styles.full]: sizes.length > 2 }, className)}
      items={sizes}
      renderChild={(size: SizeData, index) => {
        const isLast = index === sizes.length - 1;

        return (
          <>
            <div className={cn(styles.column, { [styles.last]: isLast })}>
              <div className={styles.size}>
                <div className={styles.title}>{size.title}</div>
                <div className={styles.value}>{size.value}</div>
              </div>
            </div>
            {!isLast && <span className={styles.sizeX}>х</span>}
          </>
        );
      }}
    />
  );
};

export default memo(Sizes);
